import { render, staticRenderFns } from "./TerritorialRanking.vue?vue&type=template&id=6e49a230&scoped=true&"
import script from "./TerritorialRanking.vue?vue&type=script&lang=js&"
export * from "./TerritorialRanking.vue?vue&type=script&lang=js&"
import style0 from "./TerritorialRanking.vue?vue&type=style&index=0&id=6e49a230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e49a230",
  null
  
)

export default component.exports